import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Constant } from 'src/app/shared/service/utils/contant';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { SyntheseRecettesNettesComponent } from '../synthese-recettes-nettes/synthese-recettes-nettes.component';

@Component({
  selector: 'app-titres',
  templateUrl: './titres.component.html',
  styleUrl: './titres.component.scss'
})
export class TitresComponent implements OnInit {

  exercice: number = new Date().getFullYear();
  mois: number = new Date().getMonth() + 1;
  search: string = '';

  titres: any[] = [];
  paginatedProjets: any[] = [];
  first = 0;
  rows = 10;
  totalRecords = 0;
  isLoading = false;

  selectedCompte: any = null;
  titreForm: any = {};

  moisItems = [
    { value: 1, label: 'Janvier' },
    { value: 2, label: 'Février' },
    { value: 3, label: 'Mars' },
    { value: 4, label: 'Avril' },
    { value: 5, label: 'Mai' },
    { value: 6, label: 'Juin' },
    { value: 7, label: 'Juillet' },
    { value: 8, label: 'Août' },
    { value: 9, label: 'Septembre' },
    { value: 10, label: 'Octobre' },
    { value: 11, label: 'Novembre' },
    { value: 12, label: 'Décembre' },
  ];

  @ViewChild('titreModal') titreModal: any;

  constructor(
    private modalService: NgbModal,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
    const stored = this.localStorage.getExerciceToUserToSuivieEvaluation();
    if (stored) {
      this.exercice = Number(stored) || new Date().getFullYear();
    }
    this.loadData();
  }

  loadData(): void {
    this.isLoading = false;
    this.ngxService.start();
    this.paramService.getBordereauTitres({
      annee: this.exercice,
      mois: this.mois,
      search: this.search || ''
    }).subscribe(
      (response: any) => {
        this.titres = response.data || [];
        this.totalRecords = this.titres.length;
        this.updatePaginated();
        this.isLoading = true;
        this.ngxService.stop();
      },
      (error: any) => {
        this.isLoading = true;
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue lors du chargement des titres'
        });
      }
    );
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    this.paginatedProjets = this.titres.slice(this.first, this.first + this.rows);
  }

  getMoisLabel(periode: any): string {
    if (periode === null || periode === undefined || String(periode).trim() === '') {
      return '-';
    }
    const str = String(periode).trim();
    const num = Number(str);
    if (!isNaN(num) && num >= 1 && num <= 12) {
      return this.moisItems[num - 1]?.label || str;
    }
    const isoMatch = str.match(/^\d{4}-(\d{2})/);
    if (isoMatch) {
      const m = Number(isoMatch[1]);
      return (this.moisItems[m - 1]?.label) || str;
    }
    return str;
  }

  openModal(compte: any) {
    this.selectedCompte = compte;
    const titre = compte.titres?.[0];
    this.titreForm = {
      mois: this.mois,
      annee: this.exercice,
      montant: titre?.montant || 0,
    };
    this.modalService.open(this.titreModal, { centered: true, backdrop: 'static', size: 'lg' });
  }

  save() {
    if (!this.selectedCompte) {
      return;
    }
    if (!this.titreForm.montant || Number(this.titreForm.montant) < 10000) {
      this.messageService.add({
        severity: 'warn',
        summary: Constant.suiviTitle,
        detail: 'Veuillez saisir un montant valide (minimum 10 000)'
      });
      return;
    }
    this.ngxService.start();
    this.paramService.saveBordereauTitre(this.selectedCompte.reference, this.titreForm).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.modalService.dismissAll();
        this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
        this.loadData();
      },
      (error: any) => {
        this.ngxService.stop();
        this.messageService.add({
          severity: 'error',
          summary: Constant.suiviTitle,
          detail: error?.error?.message || 'Une erreur est survenue'
        });
      }
    );
  }

  openSynthese(): void {
    const modalRef = this.modalService.open(SyntheseRecettesNettesComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.titre = 'Synthèse des recettes nettes';
  }
}
